<template>
  <div id="app" >
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  methods:{
      // mousemove: function (event) {
      //     //查看是否登录
      //     let isLogin = this.$store.state.user.userInfo.userId;
      //     if(isLogin){
      //         var nowTime = Date.parse(new Date()) /1000;
      //         var oldTime = localStorage.getItem("oldTime");
      //         if(nowTime - oldTime > 3000){
      //             console.log(11)
      //             this.$store.dispatch('user/logout').then(() => {
      //                 location.reload()// In order to re-instantiate the vue-router object to avoid bugs
      //             })
      //         }else {
      //
      //             //当前时间放入缓存
      //             localStorage.setItem("oldTime", nowTime);
      //         }
      //     }
      // },
      // 监听浏览器是否关闭
      // browerStatus(){
      //     var that = this;
      //     console.log("浏览器刷新 || 关闭了");
      // }
  },
}
</script>
<style lang="scss" >

  body .el-table th.gutter{
    display: table-cell!important;
  }
</style>




// WEBPACK FOOTER //
// src/App.vue